import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { useCustomerDetailsStyles } from './CustomerDetails';

const AddressRow = ({
  address,
  onEdit,
  hasWorkplaceServices,
  clientLocationName,
}) => {
  const classes = useCustomerDetailsStyles();
  const {
    id,
    address_line_1,
    address_line_2,
    city,
    state,
    postal_code,
    is_primary,
  } = address || {};

  return (
    <Grid item>
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        {address ? (
          <>
            <Grid item xs={1} className={classes.cardIcon}>
              <LocationOnIcon fontSize="large" htmlColor="#D64747" />
            </Grid>
            <Grid item xs className={classes.cardTextContent}>
              <Typography className={classes.fw500}>
                {clientLocationName}
              </Typography>
              <Typography>
                {[address_line_1, address_line_2].filter(Boolean).join(', ')}
              </Typography>
              <Typography>
                {city && `${city},`} {state} {postal_code}
              </Typography>
              <Typography className={classes.gray}>
                {is_primary && 'Primary'}
              </Typography>
            </Grid>
          </>
        ) : (
          <Grid item xs>
            <Typography className={classes.gray}>
              No primary {hasWorkplaceServices ? 'client location' : 'shop'} set
            </Typography>
          </Grid>
        )}
        <Grid item>
          <IconButton size="small" onClick={() => onEdit(id)}>
            <EditIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AddressRow;
